module.exports = __webpack_public_path__ + "static/media/events.ac90093b.png";